import React from 'react'
import { useSelector } from 'react-redux'
import { Container } from '../../../components'
import { Form } from './form'

const content = {
  en: 'If you are a nonprofit , school, faith-based, government or civic organization that would like to partner with us to recruit and manage volunteers, please complete the information below.',
  id: 'Jika kamu adalah perwakilan dari organisasi, lembaga ataupun komunitas yang memiliki fokus pada gerakan P/CVE di Indonesia dan ingin tergabung pada Knowledge Hub. Silakan lengkapi informasi di bawah ini'
}

const MainContent = () => {
  const language = useSelector(state => state.system.language)

  return (
    <Container>
      <div className="flex flex-wrap pt-8 pb-16 lg:pt-20 lg:pb-24 justify-center">
        <main className="w-full md:w-8/12 lg:w-6/12">
          <p className="text-sm text-gray-444 mb-10">
            {content[language.name]}
          </p>
          <Form />
        </main>
      </div>
    </Container>
  )
}

export { MainContent }
